import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import { InjectedFormikProps, withFormik } from 'formik'

import Button        from '@material-ui/core/Button'
import Dialog        from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle   from '@material-ui/core/DialogTitle'

import { EnhancedTextField } from '../atoms'
import {
  genValueMapper,
  mapFormikToMuiProps,
  proxyFormikSubmission,
}                            from './form-utils'
import {
  emptyTripartitaStudentInitial,
  tripartitaStudentInitialSchema,
  TripartitaStudentInitialValues,
}                            from './schemas/tripartita.schema'

interface TripartitaInitialStudentFormProps {
  isOpen: boolean
  close: () => void
  onSubmit: (values: TripartitaStudentInitialValues) => void
}

type Props = InjectedFormikProps<TripartitaInitialStudentFormProps, TripartitaStudentInitialValues>

const TripartitaStudentInitialForm = (props: Props) => {
  const {
    isOpen,
    submitForm,
    close,
  } = props

  const mapper = mapFormikToMuiProps(props)

  return (
    <Dialog fullWidth open={isOpen}>
      <DialogTitle>
        <FormattedMessage id={'generic.editTripartita'} />
      </DialogTitle>
      <DialogContent>
        <EnhancedTextField
          fullWidth
          margin={'dense'}
          {...mapper('indicators')}
        />
      </DialogContent>
      <DialogActions>
        <Button color={'primary'} onClick={close}>
          <FormattedMessage id={'buttonActions.cancel'} />
        </Button>
        <Button color={'primary'} onClick={submitForm}>
          <FormattedMessage id={'buttonActions.save'} />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default withFormik<TripartitaInitialStudentFormProps, TripartitaStudentInitialValues>({
  validationSchema: tripartitaStudentInitialSchema,
  mapPropsToValues: genValueMapper(emptyTripartitaStudentInitial),
  handleSubmit:     proxyFormikSubmission,
})(TripartitaStudentInitialForm)



// WEBPACK FOOTER //
// ./src/components/forms/TripartitaStudentInitialForm.tsx